import React from "react";
import { languageService } from "../../../Language/language.service";
import { ButtonActionsTable } from "../../Common/Buttons";

/**
 * Generates columns for the main Reservations table.
 * @param {Object} context - The component context (this) or relevant handlers/state.
 */
export const getReservationTableColumns = (context) => {
  const { handleActionClick } = context;

  return [
    {
      Header: languageService("Reservation No."),
      accessor: "reservationNumber",
    },
    {
      Header: languageService("MR#"),
      accessor: "mrNumber",
    },
    {
      Header: languageService("Warehouse"),
      accessor: "warehouseCode",
    },
    {
      Header: languageService("Total Materials"),
      accessor: "materialQuantity",
      Cell: (row) => {
        const total = row.original.materials.length || 0;
        return <span>{total}</span>;
      },
    },
    {
      Header: languageService("Status"),
      accessor: "status",
      Cell: (row) => <span style={{ textTransform: "capitalize" }}>{languageService(row.original.status || "active")}</span>,
    },
    {
      Header: languageService("Actions"),
      accessor: "actions",
      style: { textAlign: "center" },
      Cell: (row) => {
        const item = row.original;
        const materials = item.materials || [];
        const status = (item.status || "").toLowerCase();

        const isActive = status === "active";
        const canIssue = isActive && materials.some((m) => (m.quantityReserved || 0) > (m.quantityIssued || 0));
        // debugger;
        const canReturn = isActive && materials.some((m) => (m.quantityIssued || 0) > (m.quantityReturned || 0));

        return (
          <div style={{ textAlign: "center", width: "100%" }}>
            <ButtonActionsTable handleClick={() => handleActionClick("View", item)} buttonText={languageService("View")} />
            {"  "}

            {isActive && (
              <ButtonActionsTable handleClick={() => handleActionClick("Release", item)} buttonText={languageService("Release")} />
            )}

            {"  "}

            {canIssue && <ButtonActionsTable handleClick={() => handleActionClick("Issue", item)} buttonText={languageService("Issue")} />}

            {"  "}

            {canReturn && (
              <ButtonActionsTable handleClick={() => handleActionClick("Return", item)} buttonText={languageService("Return")} />
            )}
          </div>
        );
      },
    },
  ];
};



// WEBPACK FOOTER //
// ./src/components/IMS/Reservation/reservationTableColumns.js